export default "__VITE_ASSET__a36279c8__"